var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"minder-container"}},[_c('div',{staticClass:"btn-box"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.downloadKnowledge}},[_vm._v("下 载")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }